import React from 'react';

const NotFoundPage = () => (
  <div>
    The page you're trying to reach can't be found.
  </div>
);

export default NotFoundPage;
